var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"transaction_amount",class:_vm.props.transaction.cssClasses()},[_vm._v(" "+_vm._s(_vm.props.transaction.fAmount({sign: 'mobile'})))])}
var staticRenderFns = []

export { render, staticRenderFns }